import styled from 'styled-components';

export const Container = styled.div`
  background: white;
  padding: 20px;
  overflow: hidden;
`;
